module.exports = __webpack_public_path__ + "img/yangMiddle.3a8d05bd.jpg";